import { render, staticRenderFns } from "./Shapechanger.vue?vue&type=template&id=fd52375e&scoped=true&"
import script from "./Shapechanger.vue?vue&type=script&lang=js&"
export * from "./Shapechanger.vue?vue&type=script&lang=js&"
import style0 from "./Shapechanger.vue?vue&type=style&index=0&id=fd52375e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd52375e",
  null
  
)

export default component.exports